/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from 'ng2-bootstrap/popover/popover-container.component';
import * as i3 from 'ng2-bootstrap/popover/popover.config';
const styles_PopoverContainerComponent:any[] = ([] as any[]);
export const RenderType_PopoverContainerComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_PopoverContainerComponent,data:{}});
function View_PopoverContainerComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'h3',[['class',
      'popover-title']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['','']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.title;
    _ck(_v,1,0,currVal_0);
  });
}
export function View_PopoverContainerComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(2,[(_l()(),i0.ɵted((null as any),['\n'])),(_l()(),i0.ɵeld(0,(null as any),
      (null as any),0,'div',[['class','popover-arrow arrow']],(null as any),(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n'])),
      (_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PopoverContainerComponent_1)),
      i0.ɵdid(16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵeld(0,(null as any),(null as any),1,
          'div',[['class','popover-content']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),i0.ɵncd((null as any),0),(_l()(),i0.ɵted((null as any),
          ['\n    ']))],(_ck,_v) => {
    var _co:i2.PopoverContainerComponent = _v.component;
    const currVal_0:any = _co.title;
    _ck(_v,4,0,currVal_0);
  },(null as any));
}
export function View_PopoverContainerComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'popover-container',
      [['role','tooltip'],['style','display:block;']],[[8,'className',0],[2,'show',
          (null as any)]],(null as any),(null as any),View_PopoverContainerComponent_0,
      RenderType_PopoverContainerComponent)),i0.ɵdid(49152,(null as any),0,i2.PopoverContainerComponent,
      [i3.PopoverConfig],(null as any),(null as any))],(null as any),(_ck,_v) => {
    const currVal_0:any = ((('popover in popover-' + i0.ɵnov(_v,1).placement) + ' ') + i0.ɵnov(_v,
        1).placement);
    const currVal_1:boolean = !i0.ɵnov(_v,1).isBs3;
    _ck(_v,0,0,currVal_0,currVal_1);
  });
}
export const PopoverContainerComponentNgFactory:i0.ComponentFactory<i2.PopoverContainerComponent> = i0.ɵccf('popover-container',
    i2.PopoverContainerComponent,View_PopoverContainerComponent_Host_0,{placement:'placement',
        title:'title'},{},['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiZDovYS8xL3MvU29mdHdhcmVNYW5hZ2VyL25vZGVfbW9kdWxlcy9uZzItYm9vdHN0cmFwL3BvcG92ZXIvcG9wb3Zlci1jb250YWluZXIuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2Q6L2EvMS9zL1NvZnR3YXJlTWFuYWdlci9ub2RlX21vZHVsZXMvbmcyLWJvb3RzdHJhcC9wb3BvdmVyL3BvcG92ZXItY29udGFpbmVyLmNvbXBvbmVudC5kLnRzIiwibmc6Ly8vZDovYS8xL3MvU29mdHdhcmVNYW5hZ2VyL25vZGVfbW9kdWxlcy9uZzItYm9vdHN0cmFwL3BvcG92ZXIvcG9wb3Zlci1jb250YWluZXIuY29tcG9uZW50LmQudHMuUG9wb3ZlckNvbnRhaW5lckNvbXBvbmVudC5odG1sIiwibmc6Ly8vZDovYS8xL3MvU29mdHdhcmVNYW5hZ2VyL25vZGVfbW9kdWxlcy9uZzItYm9vdHN0cmFwL3BvcG92ZXIvcG9wb3Zlci1jb250YWluZXIuY29tcG9uZW50LmQudHMuUG9wb3ZlckNvbnRhaW5lckNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIlxuPGRpdiBjbGFzcz1cInBvcG92ZXItYXJyb3cgYXJyb3dcIj48L2Rpdj5cbjxoMyBjbGFzcz1cInBvcG92ZXItdGl0bGVcIiAqbmdJZj1cInRpdGxlXCI+e3t0aXRsZX19PC9oMz48ZGl2IGNsYXNzPVwicG9wb3Zlci1jb250ZW50XCI+PG5nLWNvbnRlbnQ+PC9uZy1jb250ZW50PjwvZGl2PlxuICAgICIsIjxwb3BvdmVyLWNvbnRhaW5lcj48L3BvcG92ZXItY29udGFpbmVyPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDRUE7TUFBQTtNQUF3Qzs7SUFBQTtJQUFBOzs7O29CQUZ4Qyx1Q0FDQTtNQUFBO01BQUEsNENBQXVDO01BQ3ZDO2FBQUE7VUFBQSx3QkFBc0Q7VUFBQTtVQUFBLHFDQUE2QixrQkFBK0I7VUFBQTs7SUFBeEY7SUFBMUIsV0FBMEIsU0FBMUI7Ozs7b0JDRkE7TUFBQTtVQUFBOzBDQUFBLFVBQUE7TUFBQTtJQUFBO1FBQUE7SUFBQTtJQUFBLFdBQUEsbUJBQUE7Ozs7OyJ9



// WEBPACK FOOTER //
// ./Client/$$_gendir/~/ng2-bootstrap/popover/popover-container.component.ngfactory.ts